'use strict';
define('checkAds',['jquery.amd'], function($){
  // not 100% foolproof, but it should be triggered by most adblockers
  return function checkAds() {
    var $form = $('.ngp-form');
    if ($form) {
      var adBlockTester = document.createElement('div');
      adBlockTester.innerHTML = '&nbsp;';
      adBlockTester.className = 'adsbox';
      $form.append(adBlockTester);
      window.setTimeout(function () {
        if (window.appInsights) {
          var msg = adBlockTester.offsetHeight === 0 ? 'Ad blocker detected' : 
            'Ad blocker not detected';
          window.appInsights.trackTrace({message: msg});
        }
        $form.find('.adsbox').remove();
      }, 60);
    }
  };
});
